import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ScheduleDataAccess from '../services/scheduleDataAccess';
import ReportDataAccess from '../services/reportDataAccess';
import PubSub from 'pubsub-js';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import Auth from '../services/auth';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import DatePicker from 'react-datepicker';
import qs from 'qs';
import ReactGA from 'react-ga4';
import 'react-datepicker/dist/react-datepicker.css';
import {userTypes} from './constants/UserTypes';
import { STORAGE_KEYS } from "../components/constants/StorageKeys";

const dataAccess = new ScheduleDataAccess();
const reportDataAccess = new ReportDataAccess();
const auth = new Auth();

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
})
const styles = theme => ({
    //root: theme.mixins.gutters({
    //    paddingTop: 16,
    //    paddingBottom: 16,
    //    marginTop: theme.spacing(3),
    //}),
    root: {
        flexGrow: 1
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    pendingCodingCard: {
        borderLeft: `8px solid #F08080`
    },
    physicianQueryCard: {
        borderLeft: `8px solid #FF3399`
    },
    incompleteCard: {
        //minWidth: 240,
        borderLeft: '8px solid #F40013'
    },
    openCard: {
        //minWidth: 240,
        borderLeft: '8px solid #F5F545'
    },
    completeQuestionsCard: {
        //minWidth: 240,
        borderLeft: '8px solid #31a7ff'
    }
    , completeCard: {
        //minWidth: 240,
        borderLeft: '8px solid #17c92c'
    } , signedCard: {
        //minWidth: 240,
        borderLeft: '8px solid #333333'
    }, codingQuestion: {
        //minWidth: 240,
        borderLeft: '8px solid purple'
    },
    tatCard: {
        height: 200
    },
    tatCardReason: {
        height: 75
    },
    dateSelection: {
        marginLeft: theme.spacing(1)
    },
 button: {
    margin: theme.spacing(1),
  },
    cardTitle: {
        fontSize: '1.1rem'
    },
  dateWrapper: {
        display: 'inline-block'
    }
});


class Dashboard extends Component {
    displayName = Dashboard.name

    onViewSchedule = (path) => {

        var status = [];
        status.push(path);

        ReactGA.event({
            action: 'DashboardFolderView',
            category: path,
            label: auth.getUserType()
        });

        this.props.history.push(`/schedule/?${qs.stringify({
            'status': status
        })}`);
    }

    onViewReports = (path, overrideArchive, dateType) => {

        var status = [];
        status.push(path);

        ReactGA.event({
            action: 'DashboardFolderView',
            category: path,
            label: auth.getUserType()
        });

        if (!this.state.includeArchive && !overrideArchive && !["NotCodedAll"].includes(path)) {
            status.push("NotArchived");
        }

        let queryString = {
            'status': status
        };

        if (dateType) {
            queryString.dateType = dateType;
        }

        this.props.history.push(`/reports/?${qs.stringify(queryString)}`);

    }

    handleToDateChange = (date) => {

        this.setState({ toDate: date });
        if (moment(date).isValid()) {
            auth.setToDate(moment(date).format("MM/DD/YYYY"));
            this.setState({toDateInput: auth.getToDate()});
            this.loadSummary();
        }
    }
    handleFromDateChange = (date) => {

        this.setState({ fromDate: date });
        if (moment(date).isValid()) {
            auth.setFromDate(moment(date).format("MM/DD/YYYY"));
            this.setState({fromDateInput: auth.getFromDate()});
            this.loadSummary();
        }

    }

    onDateFilterChange = (e, filterName) => {

      this.setState({ [filterName]: e.target.value });

        if (moment(e.target.value).isValid()) {
            if (filterName === "toDateInput") {
                auth.setToDate(e.target.value);
            }

            if (filterName === "fromDateInput") {
                auth.setFromDate(e.target.value);
            }

             this.loadSummary();
        }


    }

    constructor(props) {
        super(props);
        this.state = {
            summary: {
                Completed: 0,
                CompletedWithQuestions: 0,
                InProgress: 0,
                Signed: 0,
                NeedsDictation: 0,
                PhysicianQuery: 0,
                completeToSignedTAT: 0,
                dictationToCompleteTAT: 0,
                dosToDictationTAT: 0,
                overallTAT: 0,
                CostPerCase: 0,
                NeedsDictationReimbursement: "",
                InProgressReimbursement: "",
                CompletedWithQuestionsReimbursement: "",
                CompletedReimbursement: "",
                SignedReimbursement: "",
                CodingQueriesReimbursement: "",
            },
            codedForDownload: 0,
            isLoading: true,
            toDate: moment(auth.getToDate(), 'MM/DD/YYYY'),
            fromDate: moment(auth.getFromDate(), 'MM/DD/YYYY'),
            fromDateInput: auth.getFromDate(),
            toDateInput: auth.getToDate(),
            // include archived reports only for Physician and Admin roles per US
            includeArchive: (auth.getUserType() === userTypes.Physician || auth.isInRole(STORAGE_KEYS.FACILITY_ADMIN))
        }

    }

    loadSummary() {
        var self = this;
        self.setState({
            isLoading: true, fromDate: moment(auth.getFromDate(), 'MM/DD/YYYY'),
            fromDateInput: auth.getFromDate()          
        });
        var reportStatus = [];
        reportStatus.push("CodedCasesReadyForDownload");
        let codedSummary = reportDataAccess.getSummary(reportStatus, "CodedDate", null);
        let dashboardSummary = dataAccess.getSummary(self.state.includeArchive);      
        Promise.all([codedSummary, dashboardSummary])
          .then(function (values) {
            
            self.setState({ summary: values[1], codedForDownload: values[0], isLoading: false });

            }).catch(error => {
                var summary = {
                    Completed: '--',
                    CompletedWithQuestions: '--',
                    InProgress: '--',
                    Signed: '--',
                    NeedsDictation: '--',
                    completeToSignedTAT: '--',
                    dictationToCompleteTAT: '--',
                    dosToDictationTAT: '--',
                    overallTAT: '--',
                    NeedsDictationReimbursement: 0,
                    InProgressReimbursement: 0,
                    CompletedWithQuestionsReimbursement: 0,
                    CompletedReimbursement: 0,
                    SignedReimbursement: 0,
                    PendingCoding: 0,
                    CodingQueriesReimbursement: 0,

                };

              self.setState({ isLoading: false , summary: summary});
        });

     

    }
   

    componentWillMount() {

        this.loadSummary();
        // This is where we subscribe this class to the 'GET FILES' subscription.
        // once a publish event for 'GET FILES' has been fired, FileList.subscriber() will be triggered.
        this.token = PubSub.subscribe('AccountChanged', this.loadSummary.bind(this));
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }
    
    render() {

        const { classes } = this.props;
        const { summary, codedForDownload } = this.state;
        const isCodingAccount = auth.getIsCoding()=='false'?false:true;
        const gridSize = isCodingAccount ? 3 : 4;

        return (
            <div>

                <Grid className={classes.root} container spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Grid className={classes.root} container spacing={3} justifyContent='space-between'>
                                    <Grid item>
                                        <Typography variant="h6">
                                            Dashboard
                                        </Typography>
                                        <Typography variant="subtitle1">
                                            Today is {moment().format('ddd, MMM Do')}
                                        </Typography>
                                        <Typography variant="caption">
                                            *Estimated total reimbursable amount
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                       <div className={classes.dateWrapper}>
                                        <DatePicker 
                                          disabledKeyboardNavigation
                                          selected={this.state.fromDate}
                                          onChange={this.handleFromDateChange}
                                            customInput={<div><TextField
                                            className={classes.dateSelection}
                                            id="fromDate"
                                            label="From Date"
                                            value={this.state.fromDateInput}
                                          
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                             onChange={(e) => this.onDateFilterChange(e, 'fromDateInput')}
                                        /></div>} />
                                        </div>
                                        <div className={classes.dateWrapper}>
                                        <DatePicker
                                          disabledKeyboardNavigation
                                          selected={this.state.toDate}
                                          onChange={this.handleToDateChange}
                                          customInput={<div><TextField
                                            className={classes.dateSelection}
                                            id="toDate"
                                            label="To Date"
                                            value={this.state.toDateInput}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) => this.onDateFilterChange(e, 'toDateInput')}
                                        /></div>} />
                                        </div>
                                         <Tooltip title="Refresh" disableFocusListener={true}>
                                            <IconButton className={classes.button} aria-label="Refresh" onClick={(e) => {
                                                this.loadSummary();
                                                ReactGA.event({
                                                    action: 'Dashboard',
                                                    category: 'UserTriggeredRefresh',
                                                    label: auth.getUserType()
                                                });
                                            } }>
                                            <RefreshIcon/>
                                        </IconButton>
                                         </Tooltip>

                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={gridSize} sm={6} lg={gridSize}>
                        <Card className={classes.incompleteCard}>
                            <CardContent>
                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                            Needs Dictation
                                </Typography>
                                <span style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewSchedule('NeedsDictation')}>
                                    <Typography align="center" variant="h4" component="h2">
                                         {this.state.isLoading && <CircularProgress/>}
                                        {!this.state.isLoading && summary.NeedsDictation}
                                        {!this.state.isLoading && <span>{summary.NeedsDictationReimbursement === 0 ? " " : ` (${formatter.format(summary.NeedsDictationReimbursement)})*`}</span>}
                                     </Typography>
                                </span>
                             </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewSchedule('NeedsDictation')}>View Schedule</Button>
                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={gridSize} sm={6} lg={gridSize}>
                        <Card className={classes.openCard}>
                            <CardContent>
                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                        Transcriptions In Progress
                                </Typography>
                                <span style={{textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('InProgress')}>
                                <Typography align="center" variant="h4" component="h2">
                                    {this.state.isLoading && <CircularProgress/>}
                                     {!this.state.isLoading && summary.InProgress}
                                        {!this.state.isLoading && <span>{summary.InProgressReimbursement === 0 ? " " : ` (${formatter.format(summary.InProgressReimbursement)})*`}</span>}
                                    </Typography>
                                </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('InProgress')}>View Reports</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={gridSize} sm={6} lg={gridSize}>
                        <Card className={classes.completeQuestionsCard}>
                            <CardContent>
                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                            Completed with Questions
                                </Typography>
                                <span style={{textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('CompletedWithQuestions')}>
                                <Typography align="center" variant="h4" component="h2">
                                        {this.state.isLoading && <CircularProgress/>}
                                        {!this.state.isLoading && summary.CompletedWithQuestions}
                                        {!this.state.isLoading && <span>{summary.CompletedWithQuestionsReimbursement === 0 ? " " : ` (${formatter.format(summary.CompletedWithQuestionsReimbursement)})*`}</span>}
                                    </Typography>
                                </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('CompletedWithQuestions')}>View Reports</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={gridSize} sm={6} lg={gridSize}>
                        <Card className={classes.completeCard}>
                            <CardContent>

                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                            Completed, Ready to Sign
                                        </Typography>
                                        <span style={{textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('Completed')}>
                                          <Typography align="center" variant="h4" component="h2">
                                            {this.state.isLoading && <CircularProgress/>}
                                        {!this.state.isLoading && summary.Completed}
                                        {!this.state.isLoading && <span>{summary.CompletedReimbursement === 0 ? " " : ` (${formatter.format(summary.CompletedReimbursement)})*`}</span>}
                                    </Typography>

                                        </span>

                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('Completed')}>View Reports</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={gridSize} lg={gridSize}>
                        <Card className={classes.signedCard}>
                            <CardContent>

                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                            Signed Reports
                                        </Typography>
                                        <span style={{textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('Signed')}>
                                          <Typography align="center" variant="h4" component="h2">
                                            {this.state.isLoading && <CircularProgress/>}
                                        {!this.state.isLoading && summary.Signed}
                                        {!this.state.isLoading && <span>{summary.SignedReimbursement === 0 ? " " : ` (${formatter.format(summary.SignedReimbursement)})*`}</span>}
                                    </Typography>
                                        </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('Signed')}>View Reports</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    {isCodingAccount &&
                        <React.Fragment>
                            <Grid item xs={12} sm={6} md={gridSize} lg={gridSize}>
                        <Card className={classes.physicianQueryCard}>
                            <CardContent>

                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                    Physician Queries
                                        </Typography>
                                <span style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('PhysicianQuery')}>
                                    <Typography align="center" variant="h4" component="h2">
                                        {this.state.isLoading && <CircularProgress />}
                                        {!this.state.isLoading && summary.PhysicianQuery}
                                    </Typography>
                                </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('PhysicianQuery')}>View Queries</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                            <Grid item xs={12} sm={6} md={gridSize} lg={gridSize}>
                        <Card className={classes.codingQuestion}>
                            <CardContent>

                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                            Coded, Ready for Download
                                        </Typography>
                                <span style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('CodedCasesReadyForDownload', true, 'CodedDate')}>
                                          <Typography align="center" variant="h4" component="h2">
                                            {this.state.isLoading && <CircularProgress/>}
                                        {!this.state.isLoading && codedForDownload}
                                        {!this.state.isLoading && <span>{summary.CodingQueriesReimbursement === 0 ? " " : ` (${formatter.format(summary.CodingQueriesReimbursement)})*`}</span>}
                                    </Typography>
                                </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('CodedCasesReadyForDownload', true, 'CodedDate')}>View Reports</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                            <Grid item xs={12} sm={6} md={gridSize} lg={gridSize}>
                        <Card className={classes.pendingCodingCard}>
                            <CardContent>
                                <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">
                                    Pending Coding
                                </Typography>
                                <span style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewReports('NotCodedAll')}>
                                    <Typography align="center" variant="h4" component="h2">
                                        {this.state.isLoading && <CircularProgress />}
                                        {!this.state.isLoading && summary.PendingCoding}
                                    </Typography>
                                </span>
                            </CardContent>
                            <CardActions>
                                <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewReports('NotCodedAll')}>View Reports</Button>
                            </CardActions>
                        </Card>
                            </Grid>
                        </React.Fragment>
                    }
                    <Grid container>
                        <Grid item xs={12} md sm={6}>

                            <Card className={classes.tatCard}>
                                <CardContent>
                                    <Typography variant="h5">Dictation TAT</Typography>
                                    <div className={classes.tatCardReason}>
                                        <Typography variant="body1" color="textSecondary">
                                            DOS to Time Dictation Submitted
                                    </Typography>
                                    </div>
                                    <Typography variant="h4" gutterBottom align="center">
                                        {this.state.isLoading && <span>--</span>}
                                        {!this.state.isLoading && (this.state.summary.dosToDictationTAT < 1 ? '< 1' : this.state.summary.dosToDictationTAT)} Day(s)
                                </Typography>
                                </CardContent>

                            </Card>

                        </Grid>

                        {auth.isInRole('Admin') && <Grid item xs={12} md sm={6}>

                            <Card className={classes.tatCard}>
                                <CardContent>
                                    <Typography variant="h5">Completion TAT</Typography>
                                    <div className={classes.tatCardReason}>
                                        <Typography variant="body1" color="textSecondary">
                                            Time Dictation Submitted to Time Op Report Ready for Signature
                                    </Typography>
                                    </div>
                                    <Typography variant="h4" align="center" gutterBottom>
                                        {this.state.isLoading && <span>--</span>}
                                        {!this.state.isLoading && (this.state.summary.dictationToCompleteTAT < 1 ? '< 1' : this.state.summary.dictationToCompleteTAT)} Day(s)
                                </Typography>
                                </CardContent>

                            </Card>

                        </Grid>}
                        <Grid item xs={12} md sm={6}>

                            <Card className={classes.tatCard}>
                                <CardContent>
                                    <Typography variant="h5">E-Signed TAT</Typography>
                                    <div className={classes.tatCardReason}>
                                        <Typography variant="body1" color="textSecondary">
                                            Time Op Report Ready for Signature to Time Op Report Signed
                                    </Typography>
                                    </div>
                                    <Typography variant="h4" align="center" gutterBottom>
                                        {this.state.isLoading && <span>--</span>}
                                        {!this.state.isLoading && (this.state.summary.completeToSignedTAT < 1 ? '< 1' : this.state.summary.completeToSignedTAT)} Day(s)
                                </Typography>
                                </CardContent>

                            </Card>

                        </Grid>
                        <Grid item xs={12} md sm>

                            <Card className={classes.tatCard}>
                                <CardContent>
                                    <Typography variant="h5">Overall TAT</Typography>
                                    <div className={classes.tatCardReason}>
                                        <Typography variant="body1" color="textSecondary">
                                            DOS to Time Op Report Signed
                                    </Typography>
                                    </div>
                                    <Typography variant="h4" align="center" gutterBottom>
                                        {this.state.isLoading && <span>--</span>}
                                        {!this.state.isLoading && (this.state.summary.overallTAT < 1 ? '< 1' : this.state.summary.overallTAT)} Day(s)
                                </Typography>
                                </CardContent>

                            </Card>

                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js